import React, { useState } from "react";


const contactData = {
  phone: ["+234 8101 200547"],
  email: ["adenugaib24@gmail.com"],
  location: "Nigeria",
};

function Contact() {
  const [formdata, setFormdata] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });




  
  return (
    <div className="container">
    <div className="row">
      <div className="col-12">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="contact-info d-flex flex-column align-items-center mb-4 mb-md-0">
            <i className="icon-phone mb-2"></i>
            <div className="details text-center">
              <h5><a href="tel:08101200547">Click to Direct Call</a></h5>
              {contactData.phone.map((singlePhone, index) => (
                <span key={index}>{singlePhone}</span>
              ))}
            </div>
          </div>
          <div className="contact-info d-flex flex-column align-items-center mb-4 mb-md-0">
            <i className="icon-envelope mb-2"></i>
            <div className="details text-center">
              <h5><a href="mailto:adenugaib24@gmail.com">Click to Direct Email</a></h5>
              {contactData.email.map((singleEmail, index) => (
                <span key={index}>{singleEmail}</span>
              ))}
            </div>
          </div>
          <div className="contact-info d-flex flex-column align-items-center">
            <i className="icon-location-pin mb-2"></i>
            <div className="details text-center">
              <h5>Location</h5>
              <span>{contactData.location}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  );
}

export default Contact;
